import type { FC } from 'react'
import { StructuredText } from 'react-datocms'
import styled from 'styled-components'

import { Container } from '@/components/shared/Container'

import { DatoImage } from '@/elements/global/DatoImage'

import type { AcademyAuthor } from '../AcademyContentPage'

const StyledAuthorImage = styled.div`
  margin: 60px auto 48px;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  overflow: hidden;
  @media screen and (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    margin: 40px auto 32px;
    width: 140px;
    height: 140px;
  }
`

const StyledAuthorCard = styled.div`
  text-align: center;
  margin-bottom: 32px;
  h1 {
    font-family: ${(props) => props.theme.v2.font.nantes};
    margin-bottom: 16px;
  }
  h5 {
    color: ${(props) => props.theme.v2.text.secondary};
    font-weight: 400;
    margin: 0;
  }
  @media screen and (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    margin-bottom: 24px;
    h1 {
      margin-bottom: 12px;
    }
  }
`
const StyledAuthorBio = styled.div`
  text-align: center;
  margin-bottom: 64px;
  font-family: ${(props) => props.theme.v2.font.lotaGrotesqueLight};
  @media screen and (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    margin-bottom: 48px;
  }
`

export const AuthorCard: FC<{ author: AcademyAuthor }> = ({ author }) => {
  return (
    <>
      <Container $size="narrow">
        {author.authorImage.responsiveImage && (
          <StyledAuthorImage>
            <DatoImage data={author.authorImage.responsiveImage} />
          </StyledAuthorImage>
        )}
        <StyledAuthorCard>
          <h1>
            {author.name}
            {author.qualifications && <>, {author.qualifications}</>}
          </h1>
          {author.jobTitle && <h5>{author.jobTitle}</h5>}
          {author.institution && <h5>{author.institution}</h5>}
        </StyledAuthorCard>
        <StyledAuthorBio>
          <StructuredText data={author.fullBio} />
        </StyledAuthorBio>
      </Container>
    </>
  )
}
